import React from "react";
import PropTypes from "prop-types";

//
import { Dropdown } from "react-bootstrap";
import NumberFormat from "react-number-format";
import ScrollBar from "react-perfect-scrollbar";

//
import ImageBox from "../general/ImageBox";

//
import { iconImage } from "../../redux/features/coins/actions";

function MobileAssetsList({ items, delete_asset, showAssetTransactions }) {
  const delete_asset_group = (content) => {
    let symbol = content.symbol;
    let portfolioID = content.transactions[0].portfolio_id;

    delete_asset(symbol, portfolioID);
  };

  /**
   * Convert Data
   * for split and return splited
   */
  const convertValue = (value, symbol) => {
    let str = `${value}`;
    let splited = str.split(".");

    return (
      <>
        <small className="text-black fw-bolder ms-1">
          <NumberFormat
            value={splited[0]}
            displayType={"text"}
            prefix={symbol}
            thousandSeparator={true}
            decimalSeparator="."
          />
        </small>
        {splited[1] && <small>.{splited[1]}</small>}
      </>
    );
  };

  return (
    <div className="box-items">
      {items.map((item) => (
        <div className="items" key={item.id}>
          <header>
            <div className="d-flex">
              {/* <ImageBox src={iconImage(item.symbol)} /> */}
              <div>
                <p className="text-black fw-bolder">{item.symbol}</p>
                <small className="d-flex">
                  Price : {convertValue(item?.prices?.USDT, "$")}
                </small>
                <small className="d-flex">
                  Price : {convertValue(item?.prices?.BTC, "₿")}
                </small>
              </div>
            </div>
            <Dropdown align="end" className="edit-dropdown">
              <Dropdown.Toggle className="no-border">
                <i className="las la-ellipsis-v"></i>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <ScrollBar>
                  <Dropdown.Item onClick={() => delete_asset_group(item)}>
                    <small className="text-danger d-flex align-items-center fw-bolder">
                      <i className="las la-trash text-danger"></i>
                      Delete
                    </small>
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => showAssetTransactions(item)}>
                    <small className="text-black d-flex align-items-center fw-bolder">
                      <i className="las la-edit"></i>
                      Transactions
                    </small>
                  </Dropdown.Item>
                </ScrollBar>
              </Dropdown.Menu>
            </Dropdown>
          </header>
          <div className="content zebra">
            <div className="item">
              <small>24H</small>
              <div className="text-end">
                <small
                  className={`fw-bolder ${
                    +item?.percent_change_24h?.USDT > 0
                      ? "text-success"
                      : "text-danger"
                  }`}
                >
                  ${+item?.percent_change_24h?.USDT > 0 && "+"}
                  {item?.percent_change_24h?.USDT}%
                </small>
                <small
                  className={`fw-bolder ${
                    +item?.percent_change_24h?.BTC > 0
                      ? "text-success"
                      : "text-danger"
                  }`}
                >
                  ₿{+item?.percent_change_24h?.BTC > 0 && "+"}
                  {item?.percent_change_24h?.BTC}%
                </small>
              </div>
            </div>
            <div className="item">
              <small>Holdings</small>
              <div className="text-end">
                <small className="fw-bolder text-black">
                  ${Number(item?.holding?.USDT).toFixed(2)}
                </small>
                <small className="fw-bolder text-black">
                  ₿{Number(item?.holding?.BTC).toFixed(2)}
                </small>
                <small className="fw-bolder text-muted">
                  {item.quantity} {item.symbol}
                </small>
              </div>
            </div>

            <div className="item">
              <small>Avg. Buy Price</small>
              <div className="text-end">
                <small className="d-flex">
                  {convertValue(
                    Number(item?.avgPrice?.USDT)
                      .toFixed(item.symbol === "BTC" ? 2 : 8)
                      .replace(/\.?0+$/, ""),
                    "$"
                  )}
                </small>
                <small className="d-flex">
                  {convertValue(
                    Number(item?.avgPrice?.BTC)
                      .toFixed(item.symbol === "BTC" ? 2 : 8)
                      .replace(/\.?0+$/, ""),
                    "₿"
                  )}
                </small>
              </div>
            </div>

            <div className="item">
              <small>Profit / Loss</small>
              <div className="text-end">
                <div className="d-flex align-items-center">
                  <small className="fw-bolder text-black">
                    {+item?.benefit?.USDT > 0 && "+"} ${item?.benefit?.USDT}
                  </small>

                  <small
                    className={`ms-1 fw-bolder ${
                      +item?.benefitPercent?.USDT > 0
                        ? "text-success"
                        : "text-danger"
                    }`}
                  >
                    {item?.benefitPercent?.USDT > 0 && "+"}
                    {item?.benefitPercent?.USDT}%
                  </small>
                </div>

                <div className="d-flex align-items-center">
                  <small className="fw-bolder text-black">
                    {+item?.benefit?.BTC > 0 && "+"} ₿{item?.benefit?.BTC}
                  </small>

                  <small
                    className={`ms-1 fw-bolder ${
                      +item?.benefitPercent?.BTC > 0
                        ? "text-success"
                        : "text-danger"
                    }`}
                  >
                    {item?.benefitPercent?.BTC > 0 && "+"}
                    {item?.benefitPercent?.BTC}%
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

MobileAssetsList.propTypes = {
  items: PropTypes.array.isRequired,
  delete_asset: PropTypes.func.isRequired,
  showAssetTransactions: PropTypes.func.isRequired,
};

export default MobileAssetsList;
